import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import Swal from "sweetalert2";
import * as $ from "jquery";
import { Global } from "src/app/global";

@Component({
  selector: "app-autocomplete-medicamento-procedimento",
  templateUrl: "./autocomplete-medicamento-procedimento.component.html",
  styleUrls: ["./autocomplete-medicamento-procedimento.component.css"],
})
export class AutocompleteMedicamentoProcedimentoComponent implements OnInit {
  private searchText = new BehaviorSubject<string>("");
  private listaPrescricao = [];
  private listaPosologia = [];
  mostrarLista: boolean = false;
  presenca: any;
  atendimentioId: number = null;
  itensMedicamentoSelecionados: any[] = [];
  @ViewChild("inputInicial", { static: false })
  inputInicial!: ElementRef<HTMLInputElement>;
  private buscaPosologia: BehaviorSubject<string> = new BehaviorSubject<string>(
    ""
  );
  draggedItemIndex: number | null = null;
  buscaPosologiaTexto: string = "";
  private posologiaTimeouts: { [key: number]: any } = {};
  @Output() prescricaoSalva = new EventEmitter<void>();
  timeoutBusca: number = 1500;
  favoritoSalvo: boolean = false;
  listaFavoritos: any = [];

  constructor(
    public service: ApiService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private global : Global
  ) {
    this.searchText.pipe(debounceTime(this.timeoutBusca)).subscribe((valor) => {
      if (valor.length >= 3) {
        this.buscarMedicamentoProcedimento(valor);
      }
    });

    this.buscaPosologia
      .pipe(debounceTime(this.timeoutBusca), distinctUntilChanged())
      .subscribe((valor) => {
        if (valor.length >= 3) {
          this.buscarPosologias(valor, null);
        }
      });
  }

  ngOnInit() {    
    this.authService.currentPresenca.subscribe((res) => {
      if (res) {
        this.presenca = res;
      }
    });
    this.atendimentioId = Number(this.route.snapshot.paramMap.get("uuid"));
  }

  selecionarPosologia(posologia, item): void {
    item.searchTextPosologia = "";
    this.listaPosologia = [];
    item.listaPosologia = [];
    item.posologia = posologia.descricao;
  }

  buscarPosologias(busca: string, item: any) {
    this.service
      .Get(`Posologia?descricao=${busca}`)
      .then((res: any) => {
        item.listaPosologia = res;
        this.buscaPosologiaTexto = "";
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao buscar as posologias.",
          icon: "error",
        });
      });
  }
  onInputPosologiaChange(valor: string, item: any, index: number) {
    if (this.posologiaTimeouts[index]) {
      clearTimeout(this.posologiaTimeouts[index]);
    }
    if (valor.trim().length >= 3) {
      this.posologiaTimeouts[index] = setTimeout(() => {
        this.buscarPosologias(valor.trim().replace(/\+/g, "%2B"), item);
      }, 1500);
    } else {
      item.listaPosologia = [];
    }
  }
  onInputChange(valor: string) {
    this.searchText.next(valor.trim().replace(/\+/g, "%2B"));
  }

  buscarMedicamentoProcedimento(busca: any) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Get(
        `Medicamento/MedicamentosEProcedimentos?busca=${busca}&skip=1&take=500`
      )
      .then((res: any) => {
        this.mostrarLista = true;
        if (res.conteudo.length > 0) {
          this.listaPrescricao = res.conteudo;
          this.inputInicial.nativeElement.value = "";
          Swal.close();
        }
        Swal.close();
      })
      .catch((err) => {
        Swal.close();
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro na busca.",
          icon: "error",
        });
      });
  }
  adicionarNovoItem() {
    this.mostrarLista = false;

    if (this.inputInicial.nativeElement.value.trim() === "") {
      return;
    }

    const exists = this.itensMedicamentoSelecionados.some(
      (i) =>
        i.nome.toLowerCase().trim() ===
        this.inputInicial.nativeElement.value.trim()
    );
    if (!exists) {
      this.itensMedicamentoSelecionados.push({
        nome: this.inputInicial.nativeElement.value,
        medicamentoId: null,
        sigtapId: null,
        tipoPrescricao: 3,
      });
    }
    if (this.inputInicial) {
      this.inputInicial.nativeElement.value = "";
    }

    this.favoritoSalvo = true;
  }

  selecionarItem(item: any) {
    const exists = this.itensMedicamentoSelecionados.some(
      (i) =>
        i.id === item.id &&
        i.nome.toLowerCase().trim() === item.nome.toLowerCase().trim()
    );
    if (!exists) {
      this.itensMedicamentoSelecionados.push(item);
    }
    this.mostrarLista = false;
    this.listaPrescricao = [];
    this.favoritoSalvo = true;
  }

  deletaItemSelecionado(item: any) {
    this.itensMedicamentoSelecionados =
      this.itensMedicamentoSelecionados.filter((i) => i.id !== item.id);
    if (this.itensMedicamentoSelecionados.length === 0)
      this.favoritoSalvo = false;
  }
  deletarPosologia(item: any) {
    item.posologia = undefined;
    this.buscaPosologiaTexto = "";
    this.listaPosologia = [];
  }

  salvarPrescricao() {
    var request = this.montarObjetoRequest();

    this.service.Post("PrescricaoUrgenciaV2", request).then(
      (res) => {
        this.itensMedicamentoSelecionados = [];
        this.favoritoSalvo = false;
        this.prescricaoSalva.emit();
        Swal.fire({
          title: "Sucesso!",
          text: "Prescrição salva com sucesso.",
          icon: "success",
        });
      },
      (err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao salvar a prescrição.",
          icon: "error",
        });
      }
    );
  }
  adicionarNovaPosologia(item) {
    if (item.searchTextPosologia.trim()) {
      Swal.fire({
        title: "Deseja salvar a posologia?",
        text: `Descrição: ${item.searchTextPosologia.trim()}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          const posologiaRequest = {
            descricao: item.searchTextPosologia.trim(),
          };

          item.posologia = item.searchTextPosologia.trim();
          item.searchTextPosologia = "";

          this.service.Post("Posologia", posologiaRequest).then(
            (res) => {
              Swal.fire({
                title: "Sucesso!",
                text: "Posologia salva com sucesso.",
                icon: "success",
              }).then(() => {
                this.inputInicial.nativeElement.focus();
              });
            },
            (err) => {
              console.error("Erro ao salvar a posologia:", err);
              Swal.fire({
                title: "Erro!",
                text: "Ocorreu um erro ao salvar a posologia.",
                icon: "error",
              });
            }
          );
        }
      });
    }
  }

  obterListaPosologia = () => {
    this.service.Get("Posologia").then((result: any) => {
      this.listaPosologia = result.conteudo;
    });
  };

  alternarOrdemPrescricao() {
    this.itensMedicamentoSelecionados = [
      ...this.itensMedicamentoSelecionados,
    ].reverse();
  }

  onDragStart(index: number) {
    this.draggedItemIndex = index;
  }

  onDragOver(event: DragEvent, index: number) {
    event.preventDefault(); // Necessário para permitir o drop
  }

  onDrop(targetIndex: number) {
    if (this.draggedItemIndex === null || this.draggedItemIndex === targetIndex)
      return;

    const draggedItem =
      this.itensMedicamentoSelecionados[this.draggedItemIndex];

    this.itensMedicamentoSelecionados.splice(this.draggedItemIndex, 1); // Remove o item antigo
    this.itensMedicamentoSelecionados.splice(targetIndex, 0, draggedItem); // Insere na nova posição

    this.draggedItemIndex = null; // Limpa o índice
  }

  montarObjetoRequest(): object {
    var request = {
      texto: "",
      presencaId: this.presenca.id,
      atendimento_id: this.atendimentioId,
      itensPrescricao: [],
    };

    this.itensMedicamentoSelecionados.forEach((item) => {
      if (item.tipo_medicamento_procedimento === "Procedimento") {
        const objProcedimento = {
          medicamentoId: null,
          prescricao: item.nome,
          sigtapId: item.id as any,
          posologia: item.posologia,
          tipoPrescricao: 1,
        };
        request.itensPrescricao.push(objProcedimento);
      } else if (item.tipo_medicamento_procedimento === "Medicamento") {
        const objMedicamento = {
          medicamentoId: item.id as any,
          prescricao: "",
          quantidade: item.quantidade,
          posologia: item.posologia,
          sigtapId: null,
          tipoPrescricao: 2,
        };
        request.itensPrescricao.push(objMedicamento);
      } else {
        const objPrescricao = {
          medicamentoId: null,
          prescricao: item.nome,
          sigtapId: null,
          posologia: item.posologia,
          tipoPrescricao: 3,
        };
        request.itensPrescricao.push(objPrescricao);
      }
    });

    return request;
  }

  adicionarFavorito() {
    var request = {
      profissional_id: this.presenca.profissional_id,
      itens_prescricao: [],
    };

    this.itensMedicamentoSelecionados.forEach((item) => {
      if (item.tipo_medicamento_procedimento === "Procedimento") {
        const objProcedimento = {
          medicamento_id: null,
          prescricao: item.nome,
          sigtap_id: item.id as any,
          posologia: item.posologia,
          tipo_prescricao: 1,
        };
        request.itens_prescricao.push(objProcedimento);
      } else if (item.tipo_medicamento_procedimento === "Medicamento") {
        const objMedicamento = {
          medicamento_id: item.id as any,
          prescricao:
            item.nome +
            "+ " +           
            item.concentracao +
            "+ " +
            item.tipo_dose,
          quantidade: item.quantidade,
          posologia: item.posologia,
          sigtap_id: null,
          tipo_prescricao: 2,
        };
        request.itens_prescricao.push(objMedicamento);
      } else {
        const objPrescricao = {
          medicamento_id: null,
          prescricao: item.nome,
          sigtap_id: null,
          posologia: item.posologia,
          tipo_prescricao: 3,
        };
        request.itens_prescricao.push(objPrescricao);
      }
    });  

    this.service.Post("PrescricaoV2Favorito", request).then(
      (res) => {
        this.favoritoSalvo = false;
        Swal.fire({
          title: "Sucesso!",
          text: "Prescrição favorita salva com sucesso.",
          icon: "success",
        });
      },
      (err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao salvar a prescrição.",
          icon: "error",
        });
      }
    );
  }

  buscarFavoritos() {
    this.service
      .Get(
        `PrescricaoV2Favorito?profissionalId=${this.presenca.profissional_id}`
      )
      .then((res: any) => {
        this.abrirModalFavoritos();
        if (res.length > 0) {
          this.listaFavoritos = res;          
        } else {
          Swal.fire({
            title: "Atenção!",
            text: "Nenhum favorito encontrado para este profissional.",
            icon: "info",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro na busca.",
          icon: "error",
        });
      });
  }
  abrirModalFavoritos = () => {
    $("#modalPrescricaoFavoritos").toggleClass("show");
    $("#modalPrescricaoFavoritos").css("display", "block");
  };
  fecharModalFavoritos = () => {
    $("#modalPrescricaoFavoritos").toggleClass("show");
    $("#modalPrescricaoFavoritos").css("display", "none");
  };
  utilizarFavorito(item: any) {
    this.itensMedicamentoSelecionados = [];

    if (item.itensPrescricao.length > 0) {
      item.itensPrescricao.forEach((i) => {
        if (i.tipoPrescricao === "MEDICAMENTO") {
          const [nomeMedicamento, concentracaoMedicamento, doseMedicamento] = i.prescricao.split("+").map(p => p.trim());

          var objMedicamento = {
            id: i.medicamentoId,
            posologia: i.posologia,
            quantidade: i.quantidade,
            concentracao: concentracaoMedicamento,
            nome: nomeMedicamento,
            forma_farmaceutica: doseMedicamento,
            tipo_dose: doseMedicamento,
            tipo_medicamento_procedimento: "Medicamento",
          };
          
          this.itensMedicamentoSelecionados.push(objMedicamento);
        } else if (i.tipoPrescricao === "PROCEDIMENTO") {
          var objProcedimento = {
            id: i.sigtapId,
            nome: i.prescricao,
            posologia: i.posologia,
            tipo_medicamento_procedimento: "Procedimento",
          };
          this.itensMedicamentoSelecionados.push(objProcedimento);
        } else {
          var objPrescricao = {
            nome: i.prescricao,
            posologia: i.posologia,
            tipo_medicamento_procedimento: "Prescrição",
          };
          this.itensMedicamentoSelecionados.push(objPrescricao);
        }
      });
      this.fecharModalFavoritos();
    } else return;
  }
    toggleDetalhes(index: number) {
    this.listaFavoritos[index].exibirDetalhes =
      !this.listaFavoritos[index].exibirDetalhes;
  }
}
